import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../context/useAuth';

export default function ProtectedRoute({ children }: Readonly<{ children: React.ReactNode }>) {
  const { isAuthenticated, isAuthLoading } = useAuth();
  const location = useLocation();

  // Wait for session restoration before deciding
  if (isAuthLoading) {
    return (
      <div className="loading-spinner">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Preserve hash and search on redirect so an MSAL auth response
    // (e.g. `/#code=…` returned by Entra ID to redirectUri "/") survives
    // the bounce to /login and can be consumed by handleRedirectPromise().
    return (
      <Navigate
        to={{ pathname: '/login', search: location.search, hash: location.hash }}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{children}</>;
}
